import React from 'react';

import TranslatedCopy from '../../intl/translated-copy';
import Pictogram from '../global/pictogram';

function AccountNumberRecoverySuccess({ closeModalLogin }) {
  return (
    <>
      <div className='AccountNumberRecoverySuccess-Message'>
        <div className='AccountNumberRecoverySuccess-Icon'>
          <span className='Icon Icon--emailFlights' />
          <Pictogram
            className='Pictogram--small'
            id={ 'circleOnNewFill' } />
        </div>
        <TranslatedCopy
          className='AccountNumberRecoverySuccess-Icon-title'
          copyID='PRO_HOME_FORGOT_MY_USER_SUCCESS_TITLE'
          tagName='p'
        />
        <TranslatedCopy
          className='AccountNumberRecoverySuccess-Icon-text'
          copyID='PRO_HOME_FORGOT_MY_USER_SUCCESS_DESCRIPTION'
          tagName='p'
        />
      </div>
      <button
        className='AccountNumberRecoverySuccess-Button'
        onClick={ closeModalLogin }>
        <TranslatedCopy copyID='PRO_HOME_FORGOT_MY_USER_SUCCESS_BUTTON' />
      </button>
    </>
  );
}

export default AccountNumberRecoverySuccess;